import {useEffect, useId, useSyncExternalStore} from "react";

import {useUserDevice} from "@pg-mono/user-device";

import {gallerySwipeOnboardingStore} from "../utils/gallery_swipe_onboarding_store";

/** @internal tests only */
export const resetGallerySwipeOnboardingStateForTests = () => {
    gallerySwipeOnboardingStore.resetForTests();
};

export const useGallerySwipeOnboarding = (slidesCount: number) => {
    const galleryId = useId();
    const {isMobile} = useUserDevice();
    const {hostId, seen} = useSyncExternalStore(
        gallerySwipeOnboardingStore.subscribe,
        gallerySwipeOnboardingStore.getSnapshot,
        gallerySwipeOnboardingStore.getServerSnapshot
    );

    const isEligible = Boolean(isMobile) && !seen && slidesCount > 1;

    useEffect(() => {
        if (!isEligible) {
            gallerySwipeOnboardingStore.releaseHost(galleryId);

            return;
        }

        gallerySwipeOnboardingStore.claimHost(galleryId);
    }, [galleryId, hostId, isEligible]);

    useEffect(() => {
        return () => {
            gallerySwipeOnboardingStore.releaseHost(galleryId);
        };
    }, [galleryId]);

    return {
        dismissOnboarding: gallerySwipeOnboardingStore.markSeen,
        shouldShowOnboarding: isEligible && hostId === galleryId
    };
};
import {useEffect, useId, useSyncExternalStore} from "react";

import {useUserDevice} from "@pg-mono/user-device";

import {gallerySwipeOnboardingStore} from "../utils/gallery_swipe_onboarding_store";

/** @internal tests only */
export const resetGallerySwipeOnboardingStateForTests = () => {
    gallerySwipeOnboardingStore.resetForTests();
};

export const useGallerySwipeOnboarding = (slidesCount: number) => {
    const galleryId = useId();
    const {isMobile} = useUserDevice();
    const {hostId, seen} = useSyncExternalStore(
        gallerySwipeOnboardingStore.subscribe,
        gallerySwipeOnboardingStore.getSnapshot,
        gallerySwipeOnboardingStore.getServerSnapshot
    );

    const isEligible = Boolean(isMobile) && !seen && slidesCount > 1;

    useEffect(() => {
        if (!isEligible) {
            gallerySwipeOnboardingStore.releaseHost(galleryId);

            return;
        }

        gallerySwipeOnboardingStore.claimHost(galleryId);
    }, [galleryId, hostId, isEligible]);

    useEffect(() => {
        return () => {
            gallerySwipeOnboardingStore.releaseHost(galleryId);
        };
    }, [galleryId]);

    return {
        dismissOnboarding: gallerySwipeOnboardingStore.markSeen,
        shouldShowOnboarding: isEligible && hostId === galleryId
    };
};
